// extracted by mini-css-extract-plugin
export var drawerPaper = "_37-0";
export var itemImage = "_37-1";